exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiselect__option:hover .text-muted[data-v-1c068d06] {\n  color: var(--darken-primary-bg-contrast-text-color) !important;\n}", ""]);

// exports
